import clsx from 'clsx';
import { Button, Text } from 'react-aria-components';

import { MaterialIcon } from '#/shared/components/MaterialIcon';
import { focusRingClassName } from '#/shared/utils/domHelper';

type SignatureInputDrawEmptyProps = {
  onPress?: () => void;
  isError?: boolean;
  className?: string;
};

export function SignatureInputDrawEmpty({ onPress, isError, className }: Readonly<SignatureInputDrawEmptyProps>) {
  return (
    <Button
      className={clsx(
        'flex w-full gap-8 justify-center items-center',
        'pl-16 pr-16 pt-32 pb-32',
        'rounded-sm',
        'text-primary',
        isError ? 'bg-surface-l0 ' : 'bg-primary-surface-l2 ',
        'hover:text-primary-shade hover:border-primary-shade hover:cursor-pointer',
        `focus:text-primary-shade ${focusRingClassName}`,
        className,
      )}
      onPress={onPress}
      aria-label={'Add signature'}
    >
      <MaterialIcon iconName={'signature'} size={'md'} />
      <Text>Add signature</Text>
    </Button>
  );
}
